<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Placeholder">
      <b-form-input @change="changeProp" v-model="field.params.placeholder" />
    </b-form-group>
    <b-form-group label-cols="3" label="Tooltip">
      <b-form-input @change="changeProp" v-model="field.params.tooltip" />
    </b-form-group>

    <b-form-group label-cols="3" label="Layout">
      <b-form-select @change="changeProp" v-model="field.params.layout">
        <option value="textarea">Plain Text</option>
        <option value="html">HTML</option>
      </b-form-select>
    </b-form-group>

    <b-form-group
      label-cols="3"
      label="Rows"
      v-if="field.params.layout != 'html'"
    >
      <b-form-input
        @change="changeProp"
        min="1"
        step="1"
        type="number"
        v-model="field.params.rows"
      />
    </b-form-group>

    <b-form-group
      label-cols="3"
      label="Length"
      v-if="field.params.layout != 'html'"
    >
      <div class="row d-flex align-items-baseline">
        <div class="col-4">
          <b-form-input
            @change="changeProp"
            min="0"
            step="1"
            type="number"
            v-model="field.params.minlength"
          />
        </div>
        <div class="col-2 align-middle">To</div>
        <div class="col-4">
          <b-form-input
            @change="changeProp"
            min="0"
            step="1"
            type="number"
            v-model="field.params.maxlength"
          />
        </div>
      </div>
    </b-form-group>

    <!-- Default Settings -->
    <b-form-group label-cols="3" label="">
      <b-form-checkbox @input="changeProp" v-model="field.default_option"
        >Has Default</b-form-checkbox
      >
    </b-form-group>

    <b-form-group
      label-cols="3"
      label="Default Value"
      v-if="field.default_option"
    >
      <b-form-textarea
        :value="field.default_value"
        @change="changeProp"
        @input="setDefault"
        v-bind="field.params"
        v-if="!is_html"
      ></b-form-textarea>
      <vue-editor
        v-if="is_html"
        v-bind="field.params"
        :value="field.default_value"
        @input="setDefault"
        output="html"
      ></vue-editor>
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import { VueEditor } from "vue2-editor";
import WidgetPropMixin from "../WidgetPropMixin.js";

export default {
  name: "TextAreaProps",
  components: { WidgetCommonProps, VueEditor },
  mixins: [WidgetPropMixin],
  computed: {
    is_html() {
      return this.field.params.layout === "html";
    },
  },
  methods: {
    setDefault(value) {
      this.$set(this.field, "default_value", value);
    },
  },
};
</script>
